import React from "react";
import styled from "styled-components";

const InvestorsLogo = ({image}) => (
  <LogoContainer>
    <LogoImage
      src={image}
      alt="investor-logo"
      width={456}
      height={130}
      sizes="(max-width: 768px) 18rem, 20rem"
      loading="lazy"
      decoding="async"
    />
  </LogoContainer>
);

const LogoContainer = styled.div`
  width: 100%;
  max-width: 200px;
  /* min-width: 0; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 60px; */
  background: transparent;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

const LogoImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 5.3rem;
  object-fit: contain;
  display: block;

  @media (max-width: 768px) {
    height: 5.12rem;
    width: 18rem;
    max-height: none;
  }
`;

export default InvestorsLogo;
